module.exports = __webpack_public_path__ + "assets/img/2021-9.a86ee97b.png";